var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bulk-revamp-awareness',{staticClass:"mt-5 mx-8",attrs:{"wrap_early":""}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"img_container"},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/redchirp-logo-square-center.png"),"alt":"RedChirp logo"}}),_vm._v(" let's connect! ")])])
}]

export { render, staticRenderFns }